import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import { CSSProperties, useContext, useMemo } from "react";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import { Box } from "@mui/material";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties) {
			if (component.properties["width"]) style.width = component.properties["width"];
			if (component.properties["height"]) style.height = component.properties["height"];
			if (component.properties["padding"]) style.padding = component.properties["padding"];
			if (component.properties["backgroundColor"]) style.backgroundColor = component.properties["backgroundColor"];
			if (component.properties["flexBox"] && component.properties["flexBox"] === "True") style.display = "flex";
		}
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context, exeMode]);
	return (
		<>
			{component.childern &&
				component.childern.map((c, i) => (
					<Box style={style} key={i} sx={{ flex: 1 }} {...args}>
						<DashboardComponent component={c} />
					</Box>
				))}
		</>
	);
}

export default Component;
